/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ChargerdefinitiondocumentsItemRequestBuilderNavigationMetadata, ChargerdefinitiondocumentsItemRequestBuilderRequestsMetadata, type ChargerdefinitiondocumentsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargerdefinitiondocuments
 */
export interface ChargerdefinitiondocumentsRequestBuilder extends BaseRequestBuilder<ChargerdefinitiondocumentsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.chargerdefinitiondocuments.item collection
     * @param id Unique identifier of the item
     * @returns {ChargerdefinitiondocumentsItemRequestBuilder}
     */
     byId(id: Guid) : ChargerdefinitiondocumentsItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ChargerdefinitiondocumentsRequestBuilderUriTemplate = "{+baseurl}/chargerdefinitiondocuments";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ChargerdefinitiondocumentsRequestBuilderNavigationMetadata: Record<Exclude<keyof ChargerdefinitiondocumentsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: ChargerdefinitiondocumentsItemRequestBuilderRequestsMetadata,
        navigationMetadata: ChargerdefinitiondocumentsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
};
/* tslint:enable */
/* eslint-enable */
